<template>
  <div class="md-layout text-center" style="">
    <notifications></notifications>
    <div
      class="
        md-layout-item
        md-size-100
        md-medium-size-100
        md-small-size-100
        md-xsmall-size-100
      "
    >
      <!--  header-color="blue" -->
      <login-card> 
        <!-- 地区选择 -->
        <div class="md-form-group" slot="inputs">
          <md-field class='input-select' style="padding-left: 8px !important; padding-right: 10px !important;">
            <md-select v-model="zone">
              <md-option v-for="item in countryArray" :key="item.code" :value="item.code">{{
                $router.history.current.query.lang === "zh-CN" ?item.cn_name :item.name
              }}</md-option>
            </md-select>
            <div id="zones" @click="$refs.zone.open()" style="position:absolute; top: 0; bottom: 0;left: 0; right: 0;z-index: 1;cursor: pointer;"/>
          </md-field>
        </div>
        <!-- 账号( 手机号 | 邮箱 ) -->
        <div class="md-form-group login-type" slot="inputs">
          <div style="display:flex;">
            <div style="width: 30%; margin-right: 1%;" v-if="type === 1">
              <md-field class='input-select' style="padding-left: 8px !important;">
                <md-select v-model="phone_fount">
                  <md-option :value="'+86'">+86</md-option>
                </md-select>
              </md-field>
            </div>
            <md-field class='input-select'>
              <md-input v-model="user" :placeholder='type === 1 ?$I18n("pls_input_phone") :$I18n("pls_input_email")'></md-input>
            </md-field>
          </div>
          <div v-if="zone == 'CN'" class="change-login-type">
            <!-- 手机 -->
            <img v-show="type === 1" @click="type = 2" src="/img/haiqora/Frame_2.png" height="18" width="18">
            <!-- 邮箱 -->
            <img v-show="type === 2" @click="type = 1" src="/img/haiqora/Frame_1.png" height="18" width="18" class="email">
          </div>
        </div>
        <!-- 后端-验证码 + 按钮 -->
        <div class="md-form-group login-type" slot="inputs">
          <div style="display: flex;justify-content: space-between;">
            <img src="/img/haiqora/Group.png" style="position: absolute; left: 12px;width: 19px; height: 19px;z-index: 1;top: 11px;" />
            <md-field class='input-select big-placeholder' style="width: 64%;padding-left: 33px !important;">
              <md-input v-model="input_vcode" :placeholder='$I18n("pls_input_vc_code")'></md-input>
            </md-field>
            <button class='input-select' style="width: 35%;" @click="api_getVcCode">
              {{countDown > 0 ?(countDown + "s") :$I18n("click_get")}}
            </button>
          </div>
        </div>

        <!-- 密码 -->
        <div class="md-form-group login-type" slot="inputs">
          <img src="/img/haiqora/Lock.png" style="position: absolute; left: 12px;width: 19px; height: 19px;z-index: 1;top: 11px;" />
          <md-field class="input-select" slot="inputs" style="padding-left: 33px !important;">
            <md-input v-model="password" :placeholder="$I18n('pls_input_password_2')" type="password"></md-input>
          </md-field>
        </div>
        <!-- 密码-再次输入 -->
        <div class="md-form-group login-type" slot="inputs">
          <img src="/img/haiqora/Lock.png" style="position: absolute; left: 12px;width: 19px; height: 19px;z-index: 1;top: 11px;" />
          <md-field class="input-select" slot="inputs" style="padding-left: 33px !important;">
            <md-input v-model="password_c" :placeholder="$I18n('pls_input_confirm_password')" type="password"></md-input>
          </md-field>
        </div>
        <div class="footer" slot="footer">
          <div class="read-and-agree">
            <md-checkbox v-model="readAgree"></md-checkbox>
            <span>Read and agree to the 
              <a target="_blank" style="color: #578EFF;" :href="`https://www.iotisyun.com/xydzprivacypolicy/useragreement${
                $router.history.current.query.lang === 'zh-CN' ?'' :'-en'
              }.htm`">《Software Services Agreement》</a>
             and 
              <a target="_blank" style="color: #578EFF;" :href="`https://www.iotisyun.com/xydzprivacypolicy/${
                $router.history.current.query.lang === 'zh-CN' ?'' :'privacypolicy-en.htm'
              }`">《Privacy Policy》</a>
            </span>
          </div>
          <button class="diy-submit " @click="submit">
            {{$I18n("register_1")}}
          </button>
          <div class="diy-footer register">
            <div>Already have an account, <i @click="() => $gopage('/login')">log in directly</i></div>         
          </div>
        </div>
      </login-card>
    </div>
    <zone-select-modal ref="zone" @select="new_zone => (zone = new_zone)"/>
  </div>
</template>
<script>

// import verification from 'verification-code';
import { LoginCard } from "@/components";
import {countryArray} from "@/common/continent.js";
import ZoneSelectModal from "@/components/Common/ZoneSelectModal";
import {passwordLegal, emailLegal}   from "@/common/tools.js";
export default {
  components: {
    LoginCard,
    ZoneSelectModal,
  },
  created(){
    if(!localStorage._zone){
      if(navigator.language === "zh-CN"){
        localStorage._zone = "CN";
        this.zone = "CN";
      } else {
        localStorage._zone = "US";
        this.zone = "US";
      }
    }
    this.$root.state.apiurl = "";
    if(localStorage._zone !== "CN"){
      this.type = 2;
    }
  },
  data() {
    return {
      countryArray: countryArray,

      type: 1,     // 手机(1)/邮箱(2)登录
      zone: localStorage._zone?localStorage._zone :"",

      input_vcode: "",
      countDown:0, // 获取验证码冷却


      user: "", // 手机|邮箱
      password  : "",
      password_c: "",
      phone_fount: "+86", // 手机号区

      readAgree: false,
    };
  },
  watch:{
    zone(val){
      localStorage._zone = val;
      if(val !== "CN"){
        this.type = 2;
      }
    },
    type(){
      this.user = "";
      this.password = "";
      this.password_c = "";
      // 重置验证码
      this.vcodeurl = "";
      this.vcode = "";
      this.input_vcode = "";
      this.countDown = 0;
    },
  },
  methods: {
    // 获取后台验证码
    api_getVcCode(){
      if(this.countDown > 0){
        return
      }
      // 校验 -- 账号
      if(this.type === 2){
        if(!this.user || !emailLegal(this.user) || this.user.length > 128){
          this.$errorMsg(this.$I18n("pls_input_email"), 3000)
          return
        }
      }
      if(this.type === 1 && (!this.user || isNaN(this.user))){
        this.$errorMsg(this.$I18n("pls_input_phone"), 3000)
        return
      }
      const isHttps = window.location.protocol === "https:";
      this.$api.__sendNumApi(100, window.appConfig.umeye_api(isHttps, window.appConfig.umeye_url), {
        client_id: "web",
        client_type: 6,
        custom_flag: window.appConfig.custom_flag,
        zone : this.zone,
      })
        // 请求 201
        .then(res => {
          if(res.h.e !== 200){
            throw res
          }
          this.$setUserInfo({
            umh_host: res.b.umh_host,
          });
          localStorage.umh_host = res.b.umh_host;
          this.$api.g_VCode({
            link_param  : this.phone_fount.replace("+",""),
            msg_param   : "",
            app_key     : window.appConfig.custom_flag,
            link_id     : this.user,
            notify_type : 5,
            push_type   : this.type === 1 ?3 :2, // 2: 邮件，3: 短信
          })
          .then(this.$Then(() => {
            this.countDown = 120;
            let cd = setInterval(() => {
              if(this.countDown === 1){
                clearInterval(cd);
              }
              this.countDown = this.countDown - 1;
            } , 1000)
            this.$successMsg(this.$I18n("vc_sended"));
          }))
          .catch(this.$Catch(this.$I18n("get_error")));
        })
    },
    // 注册
    submit(){
      if(!this.readAgree){
        this.$errorMsg(this.$I18n("read_and_agree"), 3000)
        return
      }
      // 校验 -- 账号
      if(this.type === 2){
        if(!this.user || !emailLegal(this.user) || this.user.length > 128){
          this.$errorMsg(this.$I18n("pls_input_email"), 3000)
          return
        }
      }
      if(this.type === 1 && (!this.user || isNaN(this.user))){
        this.$errorMsg(this.$I18n("pls_input_phone"), 3000)
        return
      }
      // 密码不合法
      if(!this.password){
        this.$errorMsg(this.$I18n("none_pw"))
        return
      }
      if(!passwordLegal(this.password)){
        this.$errorMsg(this.$I18n("pw_inval"), 3000);
        return
      }
      if(this.password !== this.password_c){
        this.$errorMsg(this.$I18n("password_no_equal"), 3000);
        return
      }
      if(this.input_vcode === ""){
        this.$errorMsg(this.$I18n("vc_none"), 3000)
        return
      }
      // 提交数据
      const isHttps = window.location.protocol === "https:";
      this.$api.__sendNumApi(100, window.appConfig.umeye_api(isHttps, window.appConfig.umeye_url), {
        client_id: "web",
        client_type: 6,
        custom_flag: window.appConfig.custom_flag,
        zone : this.zone,
      })
        // 请求 201
        .then(res => {
          if(res.h.e !== 200){
            throw res
          }
          // 参数筛选
          let ver_type = 0;
          if(this.type === 1){ // 手机
            ver_type = 3;
          } else if(this.type === 2){ // 邮箱
            ver_type = 4;
          }
          
          this.$setUserInfo({
            umh_host: res.b.umh_host,
          });
          localStorage.umh_host = res.b.umh_host;
          return this.$api.__sendNumApi(201,window.appConfig.umeye_api(isHttps, res.b.umh_host), {
            client_id    : "web",
            client_type  : 6,
            client_lang  : this.$Param.regClientLangType.getId(this.$router.history.current.query.lang, 1),
            custom_flag  : window.appConfig.custom_flag,
            client_ver   : window.appConfig.version,
            user_id      : this.type === 1 ?this.phone_fount.replace("+","")+this.user :this.user,
            ver_type     : ver_type, // 验证类型 0：密码验证，3：手机短信，4：邮箱短信
            ver_code     : this.input_vcode,
            enc_type     : 2, // 明文
            user_passwd  : this.password,
            ...(this.type === 1 
              ? {
                user_phone: this.user,
                area_code : this.phone_fount.replace("+",""),
              }
              : {
                user_email : this.user,
              }
            ),
          })
        })
        // 处理回调
        .then(res => {
          if(res.h.e !== 200){
            throw res
          }
          this.$successMsg(this.$I18n("reg_succ"))
          localStorage.__log_type = this.type
          localStorage.__log_pass = this.password
          localStorage.__log_user = this.user
          setTimeout(() => {this.$gopage("/login")}, 2000)
        })
        .catch(res => {
          console.error(res)
          if(res && res.h){
            if(res.h.e == 514){
              this.$errorMsg(this.$I18n("error_code_514"), 3000)
            } else if(res.h.e == 406){
              this.$errorMsg(this.$I18n("error_code_406"), 3000)
            } else if(res.h.e == 512){
              this.$errorMsg(this.$I18n("error_code_512"), 3000)
            } else if(res.h.e == 409){
              this.$errorMsg(this.$I18n("error_code_409"), 3000)
            } else if(res.h.e == 8027){
              this.$errorMsg(this.$I18n("error_code_8027"), 3000)
            } else {
              this.$errorMsg(this.$I18n("reg_fail"), 3000)
            }
          } else {
            this.$errorMsg(this.$I18n("reg_fail"), 3000)
          }
        })
    },
  },
};
</script>

<style scoped>
  input::placeholder {
    font-size: 12px !important;
  }
  .read-and-agree i, .diy-footer.register i,
  .read-and-agree a, .diy-footer.register a{
    color: #578EFF;
    cursor: pointer;
  }
  .md-layout.text-center{
    width: 587px !important;
    margin-left: auto;
    margin-right: 6vw;
  }
  .read-and-agree{
    color: #333;
    width: 440px;
    margin: 0 auto;
    text-align: left;
    margin-bottom: 20px;
    opacity: .8;
  }
  .read-and-agree span{
    position: relative;
    top: -5px;

  }
  .footer{
    margin-bottom: 49px;
  }
  .diy-footer.register{
    margin: auto;
    margin-top: 25px;
    color: #000;
    font-size: 15px;
    font-weight: 400;
    justify-content: space-between;
  }
  .diy-submit{
    width: 440px;
    line-height: 69px;
    height: 69px;
    background: #578EFF;
    color: #FFFFFF;
    font-family: Microsoft YaHei;
    text-align: center;
    font-size: 30px;
    font-weight: 400;
    border: none;
    border-radius: 9px;
  }
  .md-form-group{
    width: 440px;
    margin-left : auto;
    margin-right: auto;
    margin-top: 20px;
  }
  .login-type{
    position: relative;
  }
  .change-login-type{
    position: absolute;
    right: 7px;
    top: 4px;
    height: 33px;
    width: 33px;
    border-radius: 50%;
    background: rgb(229,229,229);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .change-login-type img{
    width: 20px;
    height: 20px;
  }
  img.email{
    margin-bottom: 2px;
  }
</style>